import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Youtube } from "lucide-react";
import { CLINIC, NAV_LINKS } from "@/data/site";
import { triggerLink } from "@/lib/actions";

export const Footer = () => (
  <footer className="bg-[var(--cdt-primary-2)] text-white/90 mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center text-white font-display text-lg">C</span>
            <span className="font-display text-xl">Center Of Dental Treatment</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-7 text-white/70">
            Thoughtful, ethical, precision dentistry in {CLINIC.city}. We combine unhurried care with digital
            technology to protect your oral health for a lifetime.
          </p>
          <div className="mt-5 flex flex-col gap-2 text-sm">
            <button onClick={() => triggerLink(CLINIC.phoneHref, false)} data-testid="footer-call" className="flex items-center gap-2 hover:text-white text-left"><Phone className="h-4 w-4" /> {CLINIC.phone}</button>
            <button onClick={() => triggerLink(CLINIC.phone2Href, false)} data-testid="footer-call-2" className="flex items-center gap-2 hover:text-white text-left"><Phone className="h-4 w-4" /> {CLINIC.phone2}</button>
            <button onClick={() => triggerLink(CLINIC.emailHref, false)} data-testid="footer-email" className="flex items-center gap-2 hover:text-white text-left"><Mail className="h-4 w-4" /> {CLINIC.email}</button>
            <button onClick={() => triggerLink(CLINIC.directionsUrl, true)} data-testid="footer-directions" className="flex items-center gap-2 hover:text-white text-left"><MapPin className="h-4 w-4" /> {CLINIC.addressLine}</button>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg text-white">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            {NAV_LINKS.map((l) => (
              <li key={l.to}><Link to={l.to} className="hover:text-white">{l.label}</Link></li>
            ))}
            <li><Link to="/faq" className="hover:text-white">FAQ</Link></li>
            <li><Link to="/before-after" className="hover:text-white">Before &amp; After</Link></li>
            <li><Link to="/videos" className="hover:text-white">Patient Education</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg text-white">Working Hours</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/70">
            {CLINIC.hours.map((h) => (
              <li key={h.day} className="flex justify-between gap-3"><span>{h.day}</span><span className="text-white/90">{h.time}</span></li>
            ))}
            <li className="text-white/60 text-xs pt-1">{CLINIC.hoursNote}</li>
          </ul>
          <button onClick={() => triggerLink(CLINIC.youtube, true)} data-testid="footer-youtube" className="mt-5 inline-flex items-center gap-2 text-sm hover:text-white">
            <Youtube className="h-4 w-4" /> Patient Education Channel
          </button>
        </div>
      </div>

      <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
        <p>© {new Date().getFullYear()} Center Of Dental Treatment. All rights reserved.</p>
        <p>Ethical care · Transparent options · Long-term oral health</p>
      </div>
    </div>
  </footer>
);
